import { Component, OnInit, Inject } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AirModel } from 'src/app/models/air/air-model';
import { MarketAirProductsModel } from 'src/app/models/air/market-air-products.model';
import { SurcharDetailDialog } from '../surcharge-detail-dialog/surcharge-detail-dialog.component';
import { AirCalculatedChargesModel } from 'src/app/models/air/air-calculated-charges.model';
import { SearchLogClickHistoryService } from 'src/app/services/search-log-click-history.service';
import { SearchLogClickHistoryModel } from 'src/app/models/search-log-click-history.model';
import { FrontEndTariffModel } from 'src/app/models/front-end-tariff.model';
import { ChangeLanguageService } from 'src/app/services/change-language.service';
import { AirComponent } from 'src/app/pages/air/air.component';
import { AirSearchService } from 'src/app/services/air/air-search.service';
import { UserModel } from 'src/app/models/auth/user.model';
import { UserService } from 'src/app/services/user/user.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-air-price-detail-dialog',
  templateUrl: './air-price-detail-dialog.component.html',
  styleUrls: ['./air-price-detail-dialog.component.scss']
})
export class AirPriceDetailDialogComponent implements OnInit {

  product: MarketAirProductsModel = null;
  model: AirModel = null;
  surchargeDialogRef: DynamicDialogRef;
  lang: string = "tr";
  loading: boolean = false;
  showButton: boolean = false;
  user: UserModel = null;

  constructor(public config: DynamicDialogConfig, @Inject(AirComponent) public parent: AirComponent, private dialogService: DialogService, private airService: AirSearchService, public ref: DynamicDialogRef, private languageService: ChangeLanguageService,
  private searchLogHistoryService: SearchLogClickHistoryService, private userService: UserService, private translation: TranslateService, private messageService: MessageService) {
    this.product = this.config.data.product;
    this.model = this.config.data.model;
    this.lang =  this.languageService.getCurrentLanguage();
    this.showButton = this.config.data.showButton;


  }

  ngOnInit(): void {
  
  }

  async showSurchages(surcharge: AirCalculatedChargesModel) {
    this.surchargeDialogRef = this.dialogService.open(SurcharDetailDialog, { header: null, showHeader: false, modal: true, width: '800px', height: 'auto', closable: false, data: { surcharge: surcharge } });

    this.createClickHistory(surcharge?.name);
  }

  async showFrontEndSurchages(surcharge: FrontEndTariffModel) {
    this.surchargeDialogRef = this.dialogService.open(SurcharDetailDialog, { header: null, showHeader: false, modal: true, width: '800px', height: 'auto', closable: false, data: { surcharge: surcharge } });

    this.createClickHistory(surcharge?.name);
  }

  closeDialog() {
    this.ref.close();
  }

     createClickHistory(surchargeName: string) {
      const model = new SearchLogClickHistoryModel();

      model.searchLogId = this.model?.id || null;
      model.viewType = 'COSTVIEW';
      model.productId = this.product?.id;
      model.productName = this.product?.name;
      model.uuid = this.product?.uuid;
      model.info = surchargeName || null;

      this.searchLogHistoryService.create(model).toPromise();
    }

   async onApproveDue(product: MarketAirProductsModel) {
    const language = this.languageService.getCurrentLanguage();
    this.product = product;
    const airModel = await this.airService.insurance(this.model).toPromise();
    this.model.insurance = airModel.insurance;

    let message;
    if(language == 'tr') {
      message = product?.selectedDue ? `${product?.selectedDue.value} Gün Vade Uygulandı` : 'Peşin Uygulandı.';
    } else {
        message = product?.selectedDue ? `${product?.selectedDue.value}  Day Payment Term Has Been applied.` : 'Cash Payment Has Been Applied';
    }
    this.parent.showMessage('success', message);

  }

   getShortWeekdays(days: string[]): string {
    if (!days || days.length === 0) return "";

    const language = this.languageService.getCurrentLanguage();
  
    const allDays = ["1", "2", "3", "4", "5", "6", "7"];
    
    const weekDaysMap = {
      tr: {
        1: "Pzt",
        2: "Sal",
        3: "Çar",
        4: "Per",
        5: "Cum",
        6: "Cmt",
        7: "Paz"
      },
      en: {
        1: "Mon",
        2: "Tue",
        3: "Wed",
        4: "Thu",
        5: "Fri",
        6: "Sat",
        7: "Sun"
      }
    };
  
    const allDaysLabel = language === 'tr' ? "Her Gün" : "Every Day";
  
    if (days.length === 7 && allDays.every(day => days.includes(day))) {
      return allDaysLabel;
    }
  
    const sortedDays = days.map(Number).sort((a, b) => a - b);
  
    return sortedDays
      .map(day => weekDaysMap[language][day] || "")
      .filter(Boolean)
      .join(",");
  }


   async makeReservation(selectedProduct: MarketAirProductsModel = null, marketProductsDefId = null) {
        this.loading = true;
        this.user = await this.userService.user().toPromise();
        const approveMessage = await this.translation.get('approveMessageLabel').toPromise();
        if(this.user.status != 'AP') {
           this.loading = false;
            this.messageService.add({severity: 'warn', key: 'html-msg', summary: '', detail: approveMessage});
            return;
        }
        this.loading = false;
        this.ref.close({ selectedProduct, marketProductsDefId, makeReservation:true });
  }
}
